export enum ApiUrlPrefix {
  OLD = '/service',
  BIDS = '/api/bids',
  SYSTEM_ADMINISTRATION = '/api/system-administration',
  MARKET_BASKET_TEMPLATES = '/api/market-basket-templates',
  MEDISPAN_DRUGS_WITH_PHARMA_URL = '/api/medispan-drugs/drugs-with-pharmas',
  DOCUMENT_MANAGEMENT = '/api/document-management',
}
